import Player from './Player';
import { handleSeekingForbidden } from './utils/seekingHelpers';

export { handleSeekingForbidden };
export default Player;
